import React, { ReactElement } from 'react'

import { AccordionItem } from '@mindfulchefuk/design-system'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'
import { RecipeAllergens } from '@mindfulchefuk/features/Recipes/components/RecipeAllergens'
import { RecipeIngredients } from '@mindfulchefuk/features/Recipes/components/RecipeIngredients/RecipeIngredients'
import { Recipe } from '@mindfulchefuk/features/Recipes/interfaces'
import { usePageSource } from '@mindfulchefuk/utils/analytics/amplitude/hooks/usePageSource'
import { OnboardingRecipeModalMacrosGrid } from '@mindfulchefuk/onboarding/components/OnboardingRecipeModal/OnboardingRecipeModalRightSide/OnboardingRecipeModalAccordions/OnboardingRecipeModalMacroGrid'

type TOnboardingRecipeModalAccordions = {
  recipe: Recipe
}

export const OnboardingRecipeModalAccordions = ({
  recipe,
}: TOnboardingRecipeModalAccordions): ReactElement => {
  const pageSource = usePageSource()
  const { allergens, possibleAllergens, macros, quantifiedIngredients } = recipe

  const onAccordionClick = (category: string) => {
    trackAnalyticsEvent({
      name: 'product details toggle clicked',
      data: {
        'page source': pageSource,
        category,
        'product category': 'recipes',
        'product type': 'recipe',
        'product id': recipe.id,
        'product name': recipe.title,
      },
    })
  }
  return (
    <>
      <AccordionItem
        title="Ingredients"
        isFirst
        onClick={() => onAccordionClick('Ingredients')}
        titleColor="pepper-500"
      >
        <RecipeIngredients
          textVariant="body-lg"
          quantifiedIngredients={quantifiedIngredients}
        />
      </AccordionItem>
      <AccordionItem
        title="Allergens"
        onClick={() => onAccordionClick('Allergens')}
        titleColor="pepper-500"
      >
        <RecipeAllergens
          allergens={allergens}
          possibleAllergens={possibleAllergens}
        />
      </AccordionItem>
      <AccordionItem
        title="Macros"
        onClick={() => onAccordionClick('Macros')}
        titleColor="pepper-500"
      >
        <OnboardingRecipeModalMacrosGrid
          macrosPer100g={macros.macrosPer100g}
          macrosPerPerson={macros.macrosPerPerson}
        />
      </AccordionItem>
    </>
  )
}
